import script from "./UIBtnRound.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIBtnRound.vue?vue&type=script&lang=ts&setup=true"

import "./UIBtnRound.vue?vue&type=style&index=0&id=704b7ee2&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-704b7ee2"]])

export default __exports__